import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateExperience(idDoctorUser, experienceBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando su información de experiencia.');
    const url = `/doctor-profile-management/experience/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, experienceBody);
}
